import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order/order.service';

@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.scss']
})
export class CustomerDashboardComponent implements OnInit {
  orders: any[] = [];
  paidCount = 0;
  pendingCount = 0;

  constructor(private orderService: OrderService) {}

  loadPageData(): void {
    this.orderService.getMyOrders().subscribe(orders => {
      this.orders = orders;
      this.paidCount = orders.filter(x => x.paymentStatus === 'Paid').length;
      this.pendingCount = orders.filter(x => x.paymentStatus !== 'Paid').length;
    });
  }

  ngOnInit(): void {
    this.loadPageData();
  }
}
